import { przezmorzeApi } from "../../../api/api";
import type { PriceSettings, UpdatePriceSettingsRequest } from "@przezmorze/api-types";

export type { PriceSettings };

export async function getPriceSettings(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<PriceSettings>("/global-settings/prices", {
    signal: abortSignal,
  });
  return response.data;
}

export async function updatePriceSettings(
  body: UpdatePriceSettingsRequest,
  abortSignal?: AbortSignal,
): Promise<PriceSettings> {
  const response = await przezmorzeApi.put<PriceSettings>("/global-settings/prices", body, {
    signal: abortSignal,
  });
  return response.data;
}
